"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConnectTranslations = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _user = require("../../../entities/user");
var _translations = require("../../../entities/translations");
const useConnectTranslations = () => {
  const dispatch = (0, _reactRedux.useDispatch)();
  const token = (0, _reactRedux.useSelector)(_user.selectToken);
  const {
    api: apiUrl
  } = (0, _reactRedux.useSelector)(_user.selectUrls);
  (0, _react.useEffect)(() => {
    if (token && apiUrl) {
      dispatch((0, _translations.getLocalizationsAction)());
      dispatch((0, _translations.getLocalizationsUiAction)());
    }
  }, [token, dispatch, apiUrl]);
};
exports.useConnectTranslations = useConnectTranslations;